import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=60397c81&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=60397c81&prod&scoped=true&lang=css"
import style1 from "./FormInput.vue?vue&type=style&index=1&id=60397c81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60397c81",
  null
  
)

export default component.exports